import Joi from 'joi';

export const MoveLicenseToPaidValidator = {
  schema: Joi.object()
    .keys({
      systemRoleId: Joi.number().required()
    })
    .unknown(true)
};
